import Icon from "@ant-design/icons";

const Component = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.599611 0.600098L10.5996 0.600098M6.22461 3.93343L10.5996 3.93343M6.22461 7.26677L10.5996 7.26677M0.59961 10.6001H10.5996M1.22461 7.52318H3.09961C3.44479 7.52318 3.72461 7.17878 3.72461 6.75394V4.44625C3.72461 4.02142 3.44479 3.67702 3.09961 3.67702H1.22461C0.879431 3.67702 0.599609 4.02142 0.599609 4.44625V6.75394C0.599609 7.17878 0.879431 7.52318 1.22461 7.52318Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EngagementsIcon = (props) => (
  <Icon component={Component} {...props} />
);
